import { store } from '@/store';
import { Vue } from 'vue-property-decorator';
import { RawLocation, Route } from 'vue-router/types/router';

export function requireAuth<V extends Vue>(
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void,
) {
  if (!store.state.authentication.isAuthenticated) {
    next({ name: 'auth' });
  } else {
    next();
  }
}
